<template>
  <lottie-animation
    v-if="animation"
    ref="anim"
    :animationData="require(`../../assets/animation/${animation}.json`)"
    :loop="true"
    :autoPlay="true"
    :speed="speed"
  />
</template>

<script>
import LottieAnimation from "lottie-web-vue";

export default {
  props: {
    animation: {
      type: String,
      default: "",
    },
    speed: {
      type: Number,
      default: 1,
    },
  },
  components: {
    LottieAnimation,
  },
};
</script>
